import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useStripe } from '@stripe/react-stripe-js'

import { selectUpiPurchaseData } from 'root-redux/selects/user'
import { TAppDispatch } from 'root-redux/store/store'

import { checkUpiRedirectPaymentAction } from 'modules/purchase/redux/actions/common'

import { replaceHistory } from 'browser-history'

const STRIPE_PAYMENT_INTENT_PARAM = 'payment_intent'
const STRIPE_CLIENT_SECRET_PARAM = 'payment_intent_client_secret'
const STRIPE_REDIRECT_PARAMS = [
  STRIPE_PAYMENT_INTENT_PARAM,
  STRIPE_CLIENT_SECRET_PARAM,
  'redirect_status',
]

const removeStripeRedirectParamsFromUrl = (): void => {
  const searchParams = new URLSearchParams(window.location.search)

  STRIPE_REDIRECT_PARAMS.forEach((param) => searchParams.delete(param))

  replaceHistory({
    pathname: window.location.pathname,
    search: `?${searchParams.toString()}`,
  })
}

export const useUpiPaymentStatus = (): void => {
  const stripe = useStripe()
  const dispatch: TAppDispatch = useDispatch()
  const upiPurchaseData = useSelector(selectUpiPurchaseData)

  const isRedirectPaymentCheckedRef = useRef(false)

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    const paymentIntentId = searchParams.get(STRIPE_PAYMENT_INTENT_PARAM)
    const clientSecret = searchParams.get(STRIPE_CLIENT_SECRET_PARAM)

    if (
      !stripe ||
      !clientSecret ||
      !upiPurchaseData ||
      paymentIntentId !== upiPurchaseData.paymentIntentId ||
      isRedirectPaymentCheckedRef.current
    ) {
      return
    }

    isRedirectPaymentCheckedRef.current = true
    removeStripeRedirectParamsFromUrl()
    dispatch(checkUpiRedirectPaymentAction({ stripe, clientSecret }))
  }, [dispatch, stripe, upiPurchaseData])
}
